import { AssignmentUser } from '@dc-shared-web/hooks/api/assignment'
import { AxiosInstance } from 'axios'

export const fetchOfficeUserAssignments = async (
  apiClient: AxiosInstance,
  params: {
    officeUUID: string
    projectId?: string
  }
) => {
  const { data } = await apiClient.get<AssignmentUser[]>(
    '/api/users/assignment-users',
    {
      params: {
        officeUUID: params.officeUUID,
        projectId: params.projectId,
      },
    }
  )

  return data
}
